/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { BodyType, ErrorType } from "../../apix-handler";
import type {
  CostInboxMigrationResult,
  CostInboxMigrationStatusResponse,
  CostInboxOptInRequest,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const costInboxMigrationStatusGetV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<CostInboxMigrationStatusResponse>(
    { url: `/apix/v2/CostInboxMigration/status`, method: "GET", signal },
    options,
  );
};

export const getCostInboxMigrationStatusGetV2QueryKey = () => {
  return [`/apix/v2/CostInboxMigration/status`] as const;
};

export const getCostInboxMigrationStatusGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof costInboxMigrationStatusGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof costInboxMigrationStatusGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCostInboxMigrationStatusGetV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof costInboxMigrationStatusGetV2>>
  > = ({ signal }) => costInboxMigrationStatusGetV2(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof costInboxMigrationStatusGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CostInboxMigrationStatusGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof costInboxMigrationStatusGetV2>>
>;
export type CostInboxMigrationStatusGetV2QueryError = ErrorType<unknown>;

export function useCostInboxMigrationStatusGetV2<
  TData = Awaited<ReturnType<typeof costInboxMigrationStatusGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof costInboxMigrationStatusGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCostInboxMigrationStatusGetV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const costInboxMigrationEligibleCountGetV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/CostInboxMigration/eligible-count`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getCostInboxMigrationEligibleCountGetV2QueryKey = () => {
  return [`/apix/v2/CostInboxMigration/eligible-count`] as const;
};

export const getCostInboxMigrationEligibleCountGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof costInboxMigrationEligibleCountGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof costInboxMigrationEligibleCountGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCostInboxMigrationEligibleCountGetV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof costInboxMigrationEligibleCountGetV2>>
  > = ({ signal }) =>
    costInboxMigrationEligibleCountGetV2(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof costInboxMigrationEligibleCountGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CostInboxMigrationEligibleCountGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof costInboxMigrationEligibleCountGetV2>>
>;
export type CostInboxMigrationEligibleCountGetV2QueryError = ErrorType<unknown>;

export function useCostInboxMigrationEligibleCountGetV2<
  TData = Awaited<ReturnType<typeof costInboxMigrationEligibleCountGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof costInboxMigrationEligibleCountGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getCostInboxMigrationEligibleCountGetV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const costInboxMigrationOptInPostV2 = (
  costInboxOptInRequest: BodyType<CostInboxOptInRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<CostInboxMigrationResult>(
    {
      url: `/apix/v2/CostInboxMigration/opt-in`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: costInboxOptInRequest,
      signal,
    },
    options,
  );
};

export const getCostInboxMigrationOptInPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof costInboxMigrationOptInPostV2>>,
    TError,
    { data: BodyType<CostInboxOptInRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof costInboxMigrationOptInPostV2>>,
  TError,
  { data: BodyType<CostInboxOptInRequest> },
  TContext
> => {
  const mutationKey = ["costInboxMigrationOptInPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof costInboxMigrationOptInPostV2>>,
    { data: BodyType<CostInboxOptInRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return costInboxMigrationOptInPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CostInboxMigrationOptInPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof costInboxMigrationOptInPostV2>>
>;
export type CostInboxMigrationOptInPostV2MutationBody =
  BodyType<CostInboxOptInRequest>;
export type CostInboxMigrationOptInPostV2MutationError = ErrorType<unknown>;

export const useCostInboxMigrationOptInPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof costInboxMigrationOptInPostV2>>,
    TError,
    { data: BodyType<CostInboxOptInRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof costInboxMigrationOptInPostV2>>,
  TError,
  { data: BodyType<CostInboxOptInRequest> },
  TContext
> => {
  const mutationOptions =
    getCostInboxMigrationOptInPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
